var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeftThin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7689 15.7513L2.99467 8.62176C2.80817 8.44675 2.7002 8.23489 2.7002 8.00461C2.7002 7.80503 2.77518 7.61185 2.9081 7.46771L10.7689 0.248705C10.9358 0.0921128 11.1517 0 11.4069 0C11.9174 0 12.3002 0.368451 12.3002 0.847438C12.3002 1.06851 12.202 1.28958 12.045 1.44617L4.89897 8.00461L12.045 14.563C12.202 14.7196 12.3002 14.9315 12.3002 15.1618C12.3002 15.6408 11.9174 16 11.4069 16C11.1517 16 10.9358 15.9079 10.7689 15.7513Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeftThin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ChevronLeftThin.f76f5c58c6a1e7a299882a3fce64d29b.svg";